import React from 'react';
import classnames from 'classnames';
import { RadioButtonLabelProps } from './Types';

export const RadioButtonLabel = ({
    label,
    sublabel,
    infoButton,
    externalLinkLabel,
}: RadioButtonLabelProps): JSX.Element => (
    <>
        <legend
            className={classnames('sgw-radio-button-legend', {
                'sgw-radio-button-legend__with-sublegend': !!sublabel,
            })}
        >
            <span className="sgw-radio-button-legend-text">{label}</span>
            {infoButton && !sublabel && infoButton}
        </legend>
        {sublabel && (
            <p className="sgw-radio-button-sublegend">
                <span className="sgw-radio-button-sublegend-text">{sublabel}</span>
                {infoButton}
            </p>
        )}
        {externalLinkLabel && <div className="sgw-radio-button__external-link-label">{externalLinkLabel}</div>}
    </>
);
